module.exports = __webpack_public_path__ + "static/img/s94.17ba8b3b.png";